/** Basic console logging method names. */
export type ConsoleLogMethod = 'log' | 'info' | 'warn' | 'error' | 'debug';
